import { CheckOutlined, CloseOutlined, LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Button, Checkbox, Divider, Form, Input, Modal, Select, Space, Switch, Table, Tabs, Tooltip } from "antd"
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components"
// import ImageTabRightImage from "./ImageTabRightImage";
// import ImageTabRightPrompt from "./ImageTabRightPrompt";

const backend = process.env.REACT_APP_BACKEND
const StyledSpace = styled((props)=><Space direction="vertical" size={0} {...props}/>)`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 900px;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-left: 10px;
    overflow: auto;

    & > .ant-space-item .ant-space {
      width: 100%;
    }

    & > .ant-space-item:nth-child(1) {
      text-align: left;
    }

    & > .ant-space-item:nth-child(2) {
      flex-grow: 1;
      display: flex;
      overflow: auto;
    }
  }
`
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 92%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`


function PromptTabRight ({rightBox, stateHandler, tableParams}) {
  
  const [sourceData, setSourceData] = useState([])

  const columns = [
    {
      title: "디폴트",
      dataIndex: "default_use_yn",
      key: "default_use_yn",
      width: "50px",
      render: (_,record)=> 
        <Switch 
          disabled={record.editable ? false : true} 
          checked={_ === "Y" ? true : false}
          onChange={()=>{defaultChangeHandler(record)}}
        />
    },
    {
      title: ()=><Tooltip title="변수는 {}로 묶어서 작성해 주세요.">프롬프트 문장</Tooltip>,
      dataIndex: "statement_text",
      key: "statement_text",
      width: "500px",
      render: (_, record)=>
        <Input.TextArea 
          value={_} 
          autoSize
          style={{border: record.editable ? "" : "none"}}
          onMouseDown={record.editable ? ()=>{} : (e)=>{e.preventDefault()}}
          onChange={(e)=>{statementTextChangeHandler(e,record)}}
        />
    },
    {
      title: "기본값",
      dataIndex: "variable_default_value",
      key: "variable_default_value",
      width: "150px",
      render: (_, record)=>
        <Input.TextArea 
          value={_} 
          autoSize
          style={{border: record.editable ? "" : "none"}}
          onMouseDown={record.editable ? ()=>{} : (e)=>{e.preventDefault()}}
          onChange={(e)=>{variableDefaultValueChangeHandler(e,record)}}
        />
    },
    {
      title: "처리",
      dataIndex: "editable",
      width: "120px",
      render: (_,record) =>
      <div>
        <a style={{margin:"0px 5px"}} hidden={rightBox[1].id === 1 || rightBox[1].id === 2} onClick={(e)=>{editSaveHandler(_, record)}}>{_ ? "저장" : "수정"}</a>
        <a style={{margin:"0px 5px"}} hidden={rightBox[1].id === 1 || rightBox[1].id === 2} onClick={()=>{deleteHandler(record)}}>삭제</a>
      </div>
    },
    {}
  ]

  const getSourceData =() => {
    stateHandler("loading", true)
    axios
    .get(`${backend}/contents/new_word/prompt/statement_list/${rightBox[1].id}`)
    .then(res=>{
      const newSourceData = res.data.data.map((el,idx)=>{
          el.indexNumber = idx
          el.editable = false
          return el
        })
        setSourceData(newSourceData)
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>{
        stateHandler("loading", false)
      }) 
  }

  //저장하는 함수. 
  const editSaveHandler = (_, record) => {
    stateHandler("loading", true)
    const instance = JSON.parse(JSON.stringify(sourceData))

    if(!record.statement_text) {
      Modal.error({
        title:"에러",
        content: "프롬프트 문장은 비어있을 수 없습니다.",
        okText: "확인"
      })
      return
    }
    if(_) {
      // 저장하는 로직
      instance[record.indexNumber].editable = false
      const value = {
        id: record.id > 0 ? record.id : null,
        ContentSettingWordExDALLEPrompt_id: record.ContentSettingWordExDALLEPrompt_id,
        default_use_yn: record.default_use_yn,
        statement_text: record.statement_text,
        variable_default_value: record.variable_default_value
      }

      axios.patch(`${backend}/contents/new_word/prompt/statement/${record.id}`,{record:value})
      .then(res=>{
        const id = res.data.data.insertId || res.data.data[1].insertId
        instance[record.indexNumber].id = id
        stateHandler("reRender")
      })
      .catch(err=>{
        console.log(err)
      })

    } else {
      // 수정할 수 있도록 만드는 로직
      instance[record.indexNumber].editable = true
    }
    setSourceData(instance)
    stateHandler("loading", false)
  }

  //삭제하는 함수
  const deleteHandler = (record) => {
    stateHandler("loading", true)
    const id = record.id
    axios.delete(`${backend}/contents/new_word/prompt/statement/${record.id}`)
    .then(res=>{
      console.log(res)
      const instance = JSON.parse(JSON.stringify(sourceData))
      instance.splice(record.indexNumber,1)
      setSourceData(instance)
      stateHandler("reRender")
    })
    .catch(err=>{
      console.log(err)
    })
    .finally(()=>{
      stateHandler("loading", false)
    })
  }

  //새로운 프롬프트 문장을 추가하는 함수
  const insertHandler = () => {
    const instance = JSON.parse(JSON.stringify(sourceData))
    const ContentSettingWordExDALLEPrompt_id = rightBox[1].id
    const newIndexNumber = instance.length
    const randomID = parseInt(Math.random()*-1000000)
    let defaultUseYn = "Y"
    //기존의 기본값이 정해져 있는가에 따라 달라지도록 함.
    for(let i=0; i<instance.length; i++) {
      if(instance[i].default_use_yn === "Y"){
        defaultUseYn = "N"
        break;
      }
    }

    instance.push({
      ContentSettingWordExDALLEPrompt_id: ContentSettingWordExDALLEPrompt_id,
      default_use_yn: defaultUseYn,
      editable: true,
      id: randomID,
      indexNumber: newIndexNumber,
      statement_text: null,
      update_datetime: null,
      variable_default_value: null
    })
    setSourceData(instance)
  }

  //디폴트use를 변경하는 함수
  const defaultChangeHandler = (record) => {
    const instance = JSON.parse(JSON.stringify(sourceData))

    if(record.default_use_yn === "N") {
      for(let i = 0; i< instance.length; i++) {
        if(i === record.indexNumber) {
          instance[i].default_use_yn = "Y"
        } else {
          instance[i].default_use_yn = "N"
        }
      }
    } else {
      instance[record.indexNumber].default_use_yn = "N"
    }

    setSourceData(instance)
  }

  // 프롬프트 문장을 변경하는 함수
  const statementTextChangeHandler = (e, record) => {
    const value = e.target.value
    const instance = JSON.parse(JSON.stringify(sourceData))
    instance[record.indexNumber].statement_text = value
    setSourceData(instance)
  }

  // 변수를 변경하는 함수
  const variableDefaultValueChangeHandler = (e, record) => {
    const value = e.target.value
    const instance = JSON.parse(JSON.stringify(sourceData))
    instance[record.indexNumber].variable_default_value = value
    setSourceData(instance)
  }

  const preRecordHandler = () => {
    const {current, pageSize, total} = tableParams.pagination
    const newRowIndex = rightBox[1].indexNumber -1

    if(current === 1) {
      if(newRowIndex >= 0) {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNextRight", newRowIndex)
      }
    } else {
      if(newRowIndex < 0) {
        stateHandler("tableParams", {
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            current: current -1
          }
        })
        stateHandler("rowIndex", pageSize -1)
        // rightBox에 데이터를 넣어주는 작업을 따로 하지 않는 이유는 PromptTab에서 tableParams가 바뀌며 새로운 데이터를 불러오고,
        // rightBox가 열려 있다면 데이터를 넣어주는 작업을 따로 하기 때문이다.
      } else {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNextRight", newRowIndex)
      }
    }
  }

  const nextRecordHandler = () => {
    const {current, pageSize, total} = tableParams.pagination
    const newRowIndex = rightBox[1].indexNumber +1
    const maxPage = total%pageSize === 0 ? total/pageSize : parseInt(total/pageSize) +1
    const maxPageRow = total%pageSize || pageSize
    if(current === maxPage) {
      if(newRowIndex < maxPageRow) {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNextRight", newRowIndex)
      }
    } else {
      if(newRowIndex >= pageSize) {
        stateHandler("tableParams", {
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            current: current +1
          }
        })
        stateHandler("rowIndex", 0)
        // rightBox에 데이터를 넣어주는 작업을 따로 하지 않는 이유는 PromptTab에서 tableParams가 바뀌며 새로운 데이터를 불러오고,
        // rightBox가 열려 있다면 데이터를 넣어주는 작업을 따로 하기 때문이다.
      } else {
        stateHandler("rowIndex", newRowIndex)
        stateHandler("preNextRight", newRowIndex)
      }
    }
  }
 

  useEffect(()=>{
    if(rightBox[0] && rightBox[1]) {
      getSourceData()
    }
  },[rightBox])

  return (
    <div>
      <StyledSpace>
        <Space direction="vertical" size={0}>
          <Space size={0} style={{padding:"6px 6px 6px 10px", fontSize:"15px", fontWeight:"500"}}>프롬프트 문장 목록</Space>
          <Divider style={{display:"flex", margin:"0px"}}/>
        </Space>
        
        <Space direction="vertical" size={0} style={{padding: "10px"}}>
          <StyledTable
            columns={columns}
            dataSource={sourceData}
            rowKey="id"
            style={{flexGrow:1, overflow:"auto"}}
            scroll = {{ x:"max-content", y:"max-content"}}
            footer={()=>
              <div className="custom-footer">
                <Button onClick={insertHandler} hidden={rightBox[1].id === 1 || rightBox[1].id === 2}>프롬프트 문장 추가</Button>
              </div>}
          />
        </Space>

        <Space direction="vertical" size={0}>
          <Divider style={{display:"flex", margin:"0px"}}/>
          <Space size={0} style={{padding:"10px 6px 6px 6px", width:"100%", justifyContent:"space-between"}}>
            <Button hidden>내용 초기화</Button>
            <Space>
              <Button onClick={preRecordHandler}><LeftOutlined/>이전</Button>
              {/* <Button type="primary"><CheckOutlined/>수정</Button> */}
              <Button onClick={nextRecordHandler}><RightOutlined/>다음</Button>
              <Button onClick={()=>{stateHandler("rightBox", [false,{}])}}><CloseOutlined/>취소</Button>
            </Space>
          </Space>
        </Space>

      </StyledSpace>
    </div>
  )
}

export default PromptTabRight